import gql from 'graphql-tag'

export default gql`mutation go($url: String!){
  downloadFile(url: $url)
}`